<template>
  <div class="modal" v-bind:class="{ 'is-active': is_shown }">
    <div class="modal-background" @click="close_modal"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t("backup") }}</p>
        <button class="delete" aria-label="close" @click="close_modal"></button>
      </header>
      <section class="modal-card-body">
        <form>
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.name" />
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <div class="field">
                <input
                  class="is-checkradio"
                  type="checkbox"
                  id="chk_include_backend"
                  v-model="meta.include_backend"
                />
                <label for="chk_include_backend">{{
                  $t("include backend")
                }}</label>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <input
                  class="is-checkradio"
                  type="checkbox"
                  id="chk_include_frontend"
                  v-model="meta.include_frontend"
                />
                <label for="chk_include_frontend">{{
                  $t("include frontend")
                }}</label>
              </div>
            </div>
          </div>
        </form>
        <div class="notification is-danger mt-5" v-if="error">
          <p v-html="error"></p>
        </div>
      </section>
      <footer class="modal-card-foot">
        <p class="buttons">
          <button
            class="button is-primary is-rounded"
            v-bind:class="{ 'is-loading': is_loading }"
            :disabled="is_form_valid"
            @click="save"
          >
            <span class="icon">
              <i class="fa fa-save"></i>
            </span>
            <span>{{ $t("save") }}</span>
          </button>
          <button class="button is-rounded" @click="close_modal">
            {{ $t("cancel") }}
          </button>
        </p>
      </footer>
    </div>
  </div>
</template>
<script>
import {
  put,
  get,
  post,
  generate_error_message_text,
  change_active_tab,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import jssha1 from "js-sha1";
import currency_catalog from "../../../../../common/currency.json";

export default {
  name: "EnterpriseModal",
  components: { GenericDropdown },
  data() {
    return {
      is_shown: false,
      meta: { settings: {} },
      uuid: "",
      error: "",
      is_loading: false,
    };
  },
  computed: {
    is_form_valid() {
      let v = this;
      return (
        !v.meta.name || (!v.meta.include_backend && !v.meta.include_frontend)
      );
    },
    currencies() {
      return Object.keys(currency_catalog).map((key) => {
        return {
          value: key,
          text: currency_catalog[key].name,
        };
      });
    },
  },
  methods: {
    change_active_tab: change_active_tab,
    close_modal() {
      let v = this;
      v.is_shown = false;
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.is_shown = true;
      v.set_initial_state();
    },
    save() {
      let v = this;
      v.is_loading = true;
      let meta_copy = JSON.parse(JSON.stringify(v.meta));
      meta_copy._timeout = 60000 * 3;
      put("/core/backup", v.meta)
        .then(() => {
          v.$emit("success");
          v.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.is_loading = false;
        });
    },
    set_initial_state() {
      this.meta = {
        name: "",
        include_frontend: true,
        include_backend: true,
      };
      this.error = "";
    },
  },
  mounted() {},
};
</script>
<style></style>
